<template>
  <div>
    <img
      src="https://olaargentina.com/wp-content/uploads/2019/11/loading-gif-transparent-10.gif"
      alt="loading"
    />
    <a v-if="linkToRedirect" :href="`${linkToRedirect}`">
      <button>
        Clica aqui por favor!
      </button>
    </a>
  </div>
</template>

<script>
import { ref } from "vue";
import { getCampaignById, traffic } from "../services/api";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

export default {
  name: "form-page",
  components: {},
  data() {
    return {
      campaignId: this.$route.params.campaignId,
      linkToRedirect: null,
    };
  },
  setup() {
    const firebaseConfig = {
      apiKey: process.env.VUE_APP_API_KEY,
      authDomain: process.env.VUE_APP_AUTH_DOMAIN,
      projectId: process.env.VUE_APP_PROJECT_ID,
      storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_MESSENGER_SENDER_ID,
      appId: process.env.VUE_APP_APP_ID,
      measurementId: process.env.VUE_APP_MEASUREMENT_ID,
    };
    const firebaseApp = initializeApp(firebaseConfig);
    // Initialize Analytics and get a reference to the service
    const analytics = ref(getAnalytics(firebaseApp));
    return {
      analytics,
    };
  },
  async mounted() {
    console.log("mounted");
    // const campaignResponse = await getCampaignById(this.campaignId);
    getCampaignById(this.campaignId)
      .then((campaignResponse) => {
        console.log({data: campaignResponse});

        this.linkToRedirect = campaignResponse.redirect.url;
        logEvent(this.analytics, "page_view", {
          campaign: campaignResponse.campaign.name,
          source: "campaigns", //TODO: venueId
          page_path: campaignResponse.campaign.name,
          page_title: campaignResponse.campaign.name,
        });
        logEvent(this.analytics, "select_content", {
          campaign: campaignResponse.campaign.name,
          source: "campaigns", //TODO: venueId
          page_path: campaignResponse.campaign.name,
          page_title: campaignResponse.campaign.name,
          content_type: "redirect_to_" + campaignResponse.redirect.contentType,
          redirect_url: campaignResponse.redirect.url,
        });
        //REDIRECT
        window.location.href = campaignResponse.redirect.url;
        this.linkToRedirect = campaignResponse.redirect.url;
      })
      .catch((error) => {
        console.log({error: error});
      })
    let trafficData = {
        video_complete: false,
        video_start: false,
        page_view: true,
        utm_content: this.$route.query.utm_content,
        utm_term: this.$route.query.utm_term,
        utm_source: this.$route.query.utm_source,
        utm_campaign: this.$route.query.utm_campaign,
        utm_medium: this.$route.query.utm_medium,
        campaignId: this.$route.params.campaignId
      }
    traffic('', trafficData)
    .then((data) => {
      console.log(data);
    })
    .catch(error => console.log(error))
    // setTimeout(() => {
    //   this.linkToRedirect ? window.location.href = campaignResponse.redirect.url : null;
    // }, 5000);

  },
};
</script>
